export default __webpack_public_path__ + "static/media/github.ddf62d60.svg";